import { useEffect, useState } from 'react';
import { DarkModeContext } from './DarkModeContext.ts';

export function DarkModeProvider({ children }: { children: React.ReactNode }) {
  const [darkMode, setDarkMode] = useState(false);

  // Initialize darkMode from localStorage, or system preference if not set
  useEffect(() => {
    if (typeof window !== 'undefined') {
      // Check if darkMode is set in localStorage
      const stored = localStorage.getItem('darkMode');
      if (stored !== null) {
        setDarkMode(stored === 'true');
      } else {
        // If not in localStorage, check system preference
        setDarkMode(window.matchMedia('(prefers-color-scheme: dark)').matches);
      }
    }
  }, []);

  useEffect(() => {
    // Apply class based on darkMode state
    document.documentElement.classList.toggle('dark', darkMode === true);
    localStorage.setItem('darkMode', String(darkMode));
  }, [darkMode]);

  const toggleDarkMode = () => setDarkMode((currentMode) => !currentMode);

  return (
    <DarkModeContext.Provider value={{ darkMode, toggleDarkMode }}>
      {children}
    </DarkModeContext.Provider>
  );
}
